import { chatModelsQueryOptions } from "@/services/models-service.ts";
import { getOrgImageModelsQueryOptions } from "@/services/org-image-models-service.ts";
import { getOrgModelsQueryOptions } from "@/services/org-models-service.ts";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/settings/org")({
	beforeLoad: ({ context }) => {
		if (!context.auth.user?.isAdmin) {
			throw redirect({ to: "/settings/account" });
		}
	},
	component: Outlet,
	loader: async ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(getOrgModelsQueryOptions());
		queryClient.prefetchQuery(chatModelsQueryOptions());
		queryClient.prefetchQuery(getOrgImageModelsQueryOptions());
	},
});
